import type {
  OnyxMaybeArray,
  OnyxNamePipe,
  OnyxSuggestion,
} from '@onyx/angular';
import { castArray } from 'lodash';
import type { SimplifiedDriver } from '../../../drivers/common/interfaces/driver';

export const getSecondaryDriverSuggestions = (
  driver: OnyxMaybeArray<SimplifiedDriver>,
  namePipe: OnyxNamePipe,
): OnyxSuggestion<string>[] => {
  return castArray(driver).map((driver) => ({
    name: namePipe.transform(driver.driverData),
    value: driver.uuid,
  }));
};
